import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

// Small SVG ring that tracks the cursor while ping mode is active.
// Mounted only when the parent has entered ping mode, so the mousemove
// listener is paid for only when needed and there is zero baseline cost
// when ping mode is off.
//
// Defaults to the ping system's gold so the reticle previews what the
// in-world ring will look like.

const SIZE = 28;
const HALF = SIZE / 2;

export function PingReticle({ color = '#ffd24a' }) {
  const [pos, setPos] = useState(null);

  useEffect(() => {
    function handleMove(e) {
      setPos({ x: e.clientX, y: e.clientY });
    }
    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, []);

  if (!pos) return null;

  return h(
    'div',
    {
      'aria-hidden': 'true',
      style: {
        position: 'fixed',
        left: `${pos.x - HALF}px`,
        top: `${pos.y - HALF}px`,
        width: `${SIZE}px`,
        height: `${SIZE}px`,
        pointerEvents: 'none',
        zIndex: 9998,
      },
    },
    h(
      'svg',
      { width: SIZE, height: SIZE, viewBox: `0 0 ${SIZE} ${SIZE}` },
      h('circle', {
        cx: HALF, cy: HALF, r: HALF - 3,
        fill: 'none', stroke: color, 'stroke-width': 2,
        opacity: 0.85,
      }),
      h('circle', {
        cx: HALF, cy: HALF, r: 2,
        fill: color, opacity: 0.9,
      }),
    ),
  );
}

export default PingReticle;
